export default __webpack_public_path__ + "static/media/arrow-down.3545d37b.svg";